export default __webpack_public_path__ + "static/media/Fiche Enthousiaste.38905fa5.pdf";